var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDangertoastreact(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.395 2.543c1.151-2.016 4.058-2.016 5.21 0l4.553 7.969c1.143 2-.301 4.488-2.605 4.488H11v-2h1.554a1 1 0 00.868-1.496L8.868 3.535a1 1 0 00-1.737 0l-4.553 7.969A1 1 0 003.446 13h1.553v2H3.446C1.142 15-.302 12.512.84 10.512l4.554-7.97zM6.999 15v-2h2v2H7zm0-3V6h2v6H7z",
    fill: "#333"
  })));
}
export default SvgDangertoastreact;